var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "charging-station-page" } },
    [
      _c("div", { staticClass: "close-block" }, [
        _c(
          "a",
          {
            staticClass: "close-block-button",
            on: {
              click: function ($event) {
                return _vm.leaveChargingStation()
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "aria-hidden": "true",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("loader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.chargingStationLoadStatus == 0 ||
              _vm.chargingStationLoadStatus == 1,
            expression:
              "chargingStationLoadStatus == 0 || chargingStationLoadStatus == 1",
          },
        ],
        attrs: { width: 100, height: 100 },
      }),
      _vm._v(" "),
      _vm.chargingStationLoadStatus == 2
        ? _c("h2", { staticClass: "charging-station-title" }, [
            _vm._v(_vm._s(_vm.chargingStation.name)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.chargingStationLoadStatus == 2 && _vm.chargingStation.images.length
        ? _c(
            "div",
            { staticClass: "grid-x charging-station-image" },
            [
              _c("CoolLightBox", {
                attrs: {
                  items: [_vm.chargingStation.images[0]["imageUrl"]],
                  index: _vm.index,
                  effect: "fade",
                  slideshow: false,
                  gallery: false,
                  showCloseButton: true,
                  disableZoom: true,
                },
                on: {
                  close: function ($event) {
                    _vm.index = null
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "close",
                      fn: function () {
                        return [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z",
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3258931107
                ),
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "station-image",
                attrs: { src: _vm.chargingStation.images[0]["imageUrl"] },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "maximize" }, [
                _c(
                  "span",
                  {
                    staticClass: "show-icon",
                    on: {
                      click: function ($event) {
                        _vm.index = 0
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/img/icons/maximize.png",
                        title: "Maximize",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "features" }, [
                _c("span", { staticClass: "source" }, [
                  _vm._v(
                    _vm._s(_vm.$t("detail.imageSource")) +
                      " " +
                      _vm._s(_vm.chargingStation.provider)
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.chargingStationLoadStatus == 2
        ? _c("div", { staticClass: "grid-x" }, [
            _c("div", { staticClass: "large-12 medium-12 small-12 cell" }, [
              _c(
                "span",
                {
                  staticClass: "navigate-button-group",
                  class: { open: _vm.navigationDropdownOpen },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "navigate-button",
                      attrs: {
                        href: _vm.navigationMapLink(
                          _vm.chargingStation.latitude,
                          _vm.chargingStation.longitude
                        ),
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t("detail.navigateToChargingStationButton")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "navigation-button-dropdown",
                    on: {
                      click: [
                        function ($event) {
                          $event.stopPropagation()
                          _vm.navigationDropdownOpen = true
                        },
                        _vm.showNavigationDropdown,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.hideNavigationDropdown,
                          expression: "hideNavigationDropdown",
                        },
                      ],
                      staticClass: "navigation-button-dropdown-menu",
                    },
                    [
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.navigationMapOpen(
                                  "waze",
                                  _vm.chargingStation.latitude,
                                  _vm.chargingStation.longitude
                                )
                              },
                            },
                          },
                          [_vm._v("Waze")]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isAppleDevice()
                        ? _c("li", [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.navigationMapOpen(
                                      "apple-maps",
                                      _vm.chargingStation.latitude,
                                      _vm.chargingStation.longitude
                                    )
                                  },
                                },
                              },
                              [_vm._v("Apple Maps")]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.navigationMapOpen(
                                  "google-maps",
                                  _vm.chargingStation.latitude,
                                  _vm.chargingStation.longitude
                                )
                              },
                            },
                          },
                          [_vm._v("Google Maps")]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.chargingStationLoadStatus == 2 &&
      _vm.chargingStation.status == "under_construction"
        ? _c("div", { staticClass: "grid-x" }, [
            _c("div", { staticClass: "large-12 medium-12 small-12 cell" }, [
              _c("div", { staticClass: "station-under-construction" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("detail.stationUnderConstruction"))),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.chargingStationLoadStatus == 2
        ? _c("div", { staticClass: "grid-x" }, [
            _c("div", { staticClass: "large-12 medium-12 small-12 cell" }, [
              _c("label", { staticClass: "info-label first-label" }, [
                _vm._v(_vm._s(_vm.$t("detail.infoAboutChargingStation"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-container" }, [
                _c("span", { staticClass: "address-block" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.chargingStation.street) +
                      _vm._s(
                        _vm.chargingStation.number
                          ? " " + _vm.chargingStation.number
                          : ""
                      ) +
                      ", " +
                      _vm._s(_vm.chargingStation.city) +
                      "\n                    "
                  ),
                  _c("span", { staticClass: "address-block-copy" }, [
                    _c("span", { staticClass: "tooltip-address" }, [
                      _vm._v(_vm._s(_vm.$t("detail.tooltipCopied"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "copy-btn",
                        on: {
                          click: function ($event) {
                            _vm.copyAddressToClipBoard(
                              _vm.chargingStation.street +
                                (_vm.chargingStation.number
                                  ? " " + _vm.chargingStation.number
                                  : "") +
                                ", " +
                                _vm.chargingStation.city
                            )
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/img/icons/copy-icon.svg",
                            title: _vm.$t("detail.buttonCopyAddress"),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "gps-block" }, [
                  _vm._v(
                    "\n                    GPS: " +
                      _vm._s(
                        parseFloat(_vm.chargingStation.latitude).toFixed(5)
                      ) +
                      ", " +
                      _vm._s(
                        parseFloat(_vm.chargingStation.longitude).toFixed(5)
                      ) +
                      "\n                    "
                  ),
                  _c("span", { staticClass: "gps-block-copy" }, [
                    _c("span", { staticClass: "tooltip-gps" }, [
                      _vm._v(_vm._s(_vm.$t("detail.tooltipCopied"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "copy-btn",
                        on: {
                          click: function ($event) {
                            return _vm.copyGpsToClipBoard(
                              _vm.chargingStation.latitude +
                                ", " +
                                _vm.chargingStation.longitude
                            )
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/img/icons/copy-icon.svg",
                            title: _vm.$t("detail.buttonCopyGps"),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "recommended-card-block" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("detail.recommendedCard")) +
                      ":\n\n                    "
                  ),
                  _vm.chargingStation.provider == "ČEZ"
                    ? _c("span", [
                        _c("span", { staticClass: "provider provider-cez" }, [
                          _vm._v("ČEZ "),
                          _c("span", { staticClass: "provider-info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("detail.recommendedCardProviderInfo")
                              )
                            ),
                          ]),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "info-icon",
                            on: {
                              click: function ($event) {
                                return _vm.showRecommendedChargingCardModal()
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "info-icon",
                              attrs: { src: "/img/info-icon.svg" },
                            }),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.chargingStation.provider == "PRE" ||
                  _vm.chargingStation.provider == "fDrive" ||
                  _vm.chargingStation.provider == "ZSE" ||
                  _vm.chargingStation.provider == "CLE"
                    ? _c("span", [
                        _vm.chargingStation.cpo_id == "CZ*EON"
                          ? _c(
                              "span",
                              { staticClass: "provider-combination" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "detail.recommendedCardProviderInfoUpTo"
                                    )
                                  ) + " 99 kW "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "provider provider-cez" },
                                  [
                                    _vm._v("ČEZ "),
                                    _c(
                                      "span",
                                      { staticClass: "provider-info" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "detail.recommendedCardProviderInfo"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  ", " +
                                    _vm._s(
                                      _vm.$t(
                                        "detail.recommendedCardProviderInfoHigherPower"
                                      )
                                    ) +
                                    " "
                                ),
                                _c("span", { staticClass: "provider" }, [
                                  _vm._v("PRE "),
                                  _c("span", { staticClass: "provider-info" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "detail.recommendedCardProviderInfo"
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _c("span", { staticClass: "provider" }, [
                              _vm._v("PRE "),
                              _c("span", { staticClass: "provider-info" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("detail.recommendedCardProviderInfo")
                                  )
                                ),
                              ]),
                            ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "info-icon",
                            on: {
                              click: function ($event) {
                                return _vm.showRecommendedChargingCardModal()
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "info-icon",
                              attrs: { src: "/img/info-icon.svg" },
                            }),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.chargingStation.custom_id
                  ? _c("span", { staticClass: "station-identification" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("detail.stationIdentification")) +
                          ": "
                      ),
                      _c("span", { staticClass: "identification" }, [
                        _vm._v(_vm._s(_vm.chargingStation.custom_id)),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.chargingStationLoadStatus == 2
        ? _c("div", { staticClass: "grid-x" }, [
            _c("div", { staticClass: "large-12 medium-12 small-12 cell" }, [
              _vm.chargingStation.connectors.length
                ? _c("label", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("detail.connectors"))),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "connectors-block" },
                _vm._l(_vm.uniqueConnectors, function (connector, index) {
                  return _c("div", { key: index, staticClass: "connectors" }, [
                    connector.standard == "MENNEKES_TYPE_2"
                      ? _c("img", {
                          staticClass: "connectors-icon",
                          attrs: { src: "/img/connectors/mennekes.svg" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    connector.standard == "CHADEMO"
                      ? _c("img", {
                          staticClass: "connectors-icon",
                          attrs: { src: "/img/connectors/chademo.svg" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    connector.standard == "CCS_COMBO"
                      ? _c("img", {
                          staticClass: "connectors-icon",
                          attrs: { src: "/img/connectors/combo.svg" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    connector.standard == "TYPE_1_CONNECTOR_CABLE_ATTACHED"
                      ? _c("img", {
                          staticClass: "connectors-icon",
                          attrs: { src: "/img/connectors/type1.svg" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    connector.standard == "TYPE_F_SCHUKO" ||
                    connector.standard == "TYPE F SCHUKO"
                      ? _c("img", {
                          staticClass: "connectors-icon",
                          attrs: { src: "/img/connectors/schuko.svg" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    connector.standard == "MENNEKES_TYPE_2"
                      ? _c("span", { staticClass: "connectors-name" }, [
                          _vm._v(
                            _vm._s(
                              connector.count > 1
                                ? connector.count + "x "
                                : null
                            ) + "Mennekes"
                          ),
                          _c("br"),
                          _vm._v("(" + _vm._s(connector.power_output) + " kW)"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    connector.standard == "CHADEMO"
                      ? _c("span", { staticClass: "connectors-name" }, [
                          _vm._v(
                            _vm._s(
                              connector.count > 1
                                ? connector.count + "x "
                                : null
                            ) + "CHAdeMO"
                          ),
                          _c("br"),
                          _vm._v("(" + _vm._s(connector.power_output) + " kW)"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    connector.standard == "CCS_COMBO"
                      ? _c("span", { staticClass: "connectors-name" }, [
                          _vm._v(
                            _vm._s(
                              connector.count > 1
                                ? connector.count + "x "
                                : null
                            ) + "CCS Combo"
                          ),
                          _c("br"),
                          _vm._v("(" + _vm._s(connector.power_output) + " kW)"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    connector.standard == "TYPE_1_CONNECTOR_CABLE_ATTACHED"
                      ? _c("span", { staticClass: "connectors-name" }, [
                          _vm._v(
                            _vm._s(
                              connector.count > 1
                                ? connector.count + "x "
                                : null
                            ) + "Type 1"
                          ),
                          _c("br"),
                          _vm._v("(" + _vm._s(connector.power_output) + " kW)"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    connector.standard == "TYPE_F_SCHUKO" ||
                    connector.standard == "TYPE F SCHUKO"
                      ? _c("span", { staticClass: "connectors-name" }, [
                          _vm._v(
                            _vm._s(
                              connector.count > 1
                                ? connector.count + "x "
                                : null
                            ) + "Schuko"
                          ),
                          _c("br"),
                          _vm._v("(" + _vm._s(connector.power_output) + " kW)"),
                        ])
                      : _vm._e(),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("label", { staticClass: "info-label" }, [
                _vm._v(_vm._s(_vm.$t("detail.contact"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-container" }, [
                _vm.chargingStation.email
                  ? _c("span", { staticClass: "contact-item" }, [
                      _vm._v(_vm._s(_vm.$t("detail.contactEmail")) + ": "),
                      _c(
                        "a",
                        {
                          staticClass: "email-address",
                          attrs: {
                            href: "mailto:" + _vm.chargingStation.email,
                          },
                        },
                        [_vm._v(_vm._s(_vm.chargingStation.email))]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.chargingStation.phone
                  ? _c("span", { staticClass: "contact-item" }, [
                      _vm._v(_vm._s(_vm.$t("detail.contactPhone")) + ": "),
                      _c(
                        "a",
                        {
                          staticClass: "phone-number",
                          attrs: {
                            href: "tel:" + _vm.chargingStation.phone.trim(),
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.formatPhone(_vm.chargingStation.phone))
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.chargingStation.cpo_id
                  ? _c("span", { staticClass: "contact-item" }, [
                      _vm._v(_vm._s(_vm.$t("detail.operator")) + ": "),
                      _c(
                        "a",
                        { staticClass: "operator", attrs: { href: "#" } },
                        [_vm._v(_vm._s(_vm.chargingStation.cpo_id))]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "station-info-text",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("detail.stationAdditionalInformation")
                  ),
                },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("charging-station-recommended-card-modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }